module.exports = __webpack_public_path__ + "assets/Aa.2e2803ad.svg";